/* A burst of confetti on the #confetti canvas (the reveal page mounts one). */
export function burstConfetti(): void {
  const cv = document.getElementById("confetti") as HTMLCanvasElement | null; if (!cv) return;
  const ctx = cv.getContext("2d"); if (!ctx) return;
  cv.width = innerWidth; cv.height = innerHeight;
  const colors = ["#8A5E10", "#8A3B54", "#E08A6E", "#6B8E5A", "#F3E4C2"];
  const parts = Array.from({ length: 140 }, () => ({ x: Math.random() * cv.width, y: -20 - Math.random() * cv.height * 0.5,
    r: 5 + Math.random() * 7, c: colors[Math.floor(Math.random() * colors.length)], vy: 2 + Math.random() * 3,
    vx: -1.5 + Math.random() * 3, rot: Math.random() * 6, vr: -0.2 + Math.random() * 0.4 }));
  let frames = 0;
  (function loop() { ctx.clearRect(0, 0, cv.width, cv.height); frames++;
    parts.forEach((p) => { p.x += p.vx; p.y += p.vy; p.rot += p.vr; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
      ctx.fillStyle = p.c; ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 0.6); ctx.restore(); });
    if (frames < 220) requestAnimationFrame(loop); else ctx.clearRect(0, 0, cv.width, cv.height);
  })();
}
